import { useQuery } from '@tanstack/react-query';

import { type PolicyDetails } from '~entities/policies/modal/policy';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getAllPoliciesAPI = async () => {
  const response = await baseAPI.get<Array<PolicyDetails>>(`/policies`);
  return response.data;
};

export const useGetAllPolicies = () => {
  return useQuery({
    queryKey: [KEYS.POLICIES],
    queryFn: () => getAllPoliciesAPI(),
  });
};
